import Vue from 'vue'
import Router from 'vue-router'
import AboutComponent from './components/AboutComponent/aboutComponent'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: AboutComponent
    },
    {
      path: '/linkedin',
      beforeEnter() { location.href = "https://www.linkedin.com/in/maximiliano-adad/" }
    }
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router.js